var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding":"0px !important"}},[_c('activities',{attrs:{"isDesktop":!_vm.isMobile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }